<template>
  <div class="can-toggle toggle-switch pull-right">
    <div class="selected-value">{{ unitSystem }}</div>

    <input id="unit-system-toggle" type="checkbox" v-model="unitSystemToggle">

    <label for="unit-system-toggle">
      <div class="can-toggle__switch" data-checked="imperial" data-unchecked="metric"></div>
    </label>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  name: "UnitSystemToggle",

  computed: {
    ...mapGetters({
      unitSystem: 'userSelections/getUnitSystem',
    }),

    unitSystemToggle: {
      get() {
        return this.unitSystem === 'imperial';
      },

      set(val) {
        this.$store.commit('userSelections/setUnitSystem', (val ? 'imperial' : 'metric'));
      },
    },
  },
};
</script>

<style scoped>
  .can-toggle {
    top: -40px;
  }

  .can-toggle__switch:before,
  .can-toggle__switch:after {
    color: transparent !important;
  }

  .selected-value {
    opacity: 0.8;
    text-transform: capitalize;
    color: rgba(51, 51, 51, 0.8);
    user-select: none;
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    line-height: 1.64;
    letter-spacing: 0.7px;
    text-align: center;
    margin: 12px 0;
  }
</style>
